import PromotionCategory from './PromotionCategory';
import { toMoment } from 'api/helpers';

export default class PromotionItem {
	id = 0;
	name = '';
	end_date = null;
	categories = null;
	is_preview = false;
	start_date = null;
	targetUserId = 1;

	constructor(promo) {
		this.id = promo.Id;
		this.name = promo.Name;
		this.start_date = toMoment(promo.StartDate);
		this.end_date = toMoment(promo.EndDate);
		this.is_preview = promo.IsPreview;
		this.targetUserId = promo.TargetUserId;
		this.categories = promo.Categories.map(item => new PromotionCategory(item));
	}
}



// WEBPACK FOOTER //
// ./src/api/models/PromotionItem.js